export default "__VITE_ASSET__DO7F6mo8__"